import React from "react";

const HelpNotice = () => {
  return (
    <div className="mb-6 p-4 bg-amber-50 border border-amber-200 rounded-lg">
      <p className="text-amber-800 text-sm">
        যে কোনো প্রয়োজনে লগইন করে 'সাহায্য' বোতামের মাধ্যমে আমাদের মেসেজ পাঠান
      </p>
    </div>
  );
};

export default HelpNotice;
